import React, { useState, useEffect, } from 'react'
import HtmlParser from 'react-html-parser';

import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { isNull, isUndefined, } from 'lodash';

import $ from 'jquery';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';
import Swal from 'sweetalert2';

import axios from 'axios';

import Menu from '../main/Menu';
import PurchaseConceptAdd from './PurchaseConceptAdd';
import PurchaseConceptEdit from './PurchaseConceptEdit';
import { purchaseTaxesGetAsync, purchaseFormDataValidateAsync, purchaseSuppliersGetAsync, purchaseExpenseConceptsGetAsync, purchaseStatusGet } from '../../controllers/purchases/purchases';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, awaitDelay,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import useAuth from '../../controllers/users/useAuth';

import { purchaseDetailModelGet, purchaseModelGet, } from '../../models/expenses/purchase';
import { purchaseDetailsCalculate } from '../../controllers/expenses/purchases';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { supplierModelGet } from '../../models/expenses/suppliers';
import { conceptModelGet } from '../../models/expenses/concept';
import { taxModelGet } from '../../models/taxes/tax';

const currentMethod = 'currentMethod';

const { backend, } = globalSettings?.app;
const { icons, labels, messages, } = globalSettings;
const { properties: dbProps, } = globalSettings?.collections;

export default function PurchaseAdd({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    const neutralValue = 0.00;
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    //const [showView, setShowView] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, purchase: true, purchaseDetail: true, });
    //const [showData, setShowData] = useState(false);
    //#endregion others

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region purchase
    const purchaseDateId = 'purchaseDate';
    const [purchase, setPurchase] = useState(purchaseModelGet({ buildingId: id, supplierId: '', userId: auth?.user?.uid, }));
    const [numberError, setNumberError] = useState('');
    const [dateError, setDateError] = useState('');
    const [supplierError, setSupplierError] = useState('');
    const [purchaseNumberError, setPurchaseNumberError] = useState('');
    const [purchaseControlNumberError, setPurchaseControlNumberError] = useState('');
    const [purchaseDescriptionError, setPurchaseDescriptionError] = useState('');
    //#endregion purchase

    //#region purchase details
    const dtPurchaseDetailsId = 'dtPurchaseDetails';
    const [dtPurchaseDetailsRowIndex, setDtPurchaseDetailsRowIndex] = useState(0);
    const [purchaseDetailShowModal, setPurchaseDetailShowModal] = useState(false);
    const [purchaseDetails, setPurchaseDetails] = useState([]);
    //#endregion purchase details

    //#region suppliers
    const [suppliers, setSuppliers] = useState([]);
    //#endregion suppliers

    //#region purchase detail
    const [purchaseDetailEditDelete, setPurchaseDetailEditDelete] = useState({ expenseConceptId: '', description: '', rowIndex: 0, processType: 0, subMethod: '', });
    const [purchaseDetail, setPurchaseDetail] = useState(purchaseDetailModelGet({}));
    const [purchaseDetailEditShowModal, setPurchaseDetailEditShowModal] = useState(false);
    //#endregion purchase detail

    //#region concepts
    const [concepts, setConcepts] = useState([conceptModelGet({})]);
    const [concept, setConcept] = useState({ expenseConceptId: '', description: '', rowIndex: 0, });
    //#endregion concepts

    //#region taxes
    const [taxes, setTaxes] = useState([taxModelGet({})]);
    //#endregion taxes

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnSave',
                className: 'btn btn-outline-warning mx-1',
            },
            attachment: {
                id: 'btnAttachment',
                className: 'btn btn-outline-info',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success mx-1',
            },
        },
        checkBox: {
            isNational: {
                attributes: {
                },
                id: 'chkIsNational',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            purchaseDetails: {
                buttons: {
                    detailAdd: {
                        className: 'btn btn-sm btn-outline-info mx-1 float-right',
                        id: 'btnDtPurchaseDetailsIdDetailAdd',
                    },
                    detailEdit: {
                        className: 'btn btn-sm btn-outline-warning float-right',
                        id: 'btnDtPurchaseDetailsIdDetailEdit',
                    },
                    detailDelete: {
                        className: 'btn btn-sm btn-outline-danger mx-1 float-right',
                        id: 'btnDtPurchaseDetailsIdDetailDelete',
                    },
                },
                icons: {
                    detailAdd: {
                        id: 'iconDtPurchaseDetailsIdDetailAdd',
                        className: icons?.list,
                    },
                    detailEdit: {
                        id: 'iconDtPurchaseDetailsIdDetailEdit',
                        className: icons?.edit,
                    },
                    detailDelete: {
                        id: 'iconDtPurchaseDetailsIdDetailDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtPurchaseDetailsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchaseDetailsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    detailAdd: {
                        id: 'spDtPurchaseDetailsIdDetailAdd',
                        className: '',
                    },
                    detailEdit: {
                        id: 'spDtPurchaseDetailsIdDetailEdit',
                        className: '',
                    },
                    detailDelete: {
                        id: 'spDtPurchaseDetailsIdDetailDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'icoSave',
                className: icons?.save,
            },
            attachment: {
                id: 'icoAttachment',
                className: icons?.paperClip,
            },
            back: {
                id: 'icoBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            purchaseNumber: {
                id: 'inputPurchaseNumber',
                className: 'form-control',
            },
            date: {
                id: 'inputDate',
                className: 'form-control text-black bg-transparent datetimepicker-input',
            },
            purchaseNumberSupplier: {
                id: 'inputPurchaseNumberSupplier',
                className: 'form-control',
            },
            purchaseControlNumberSupplier: {
                id: 'inputPurchaseControlNumberSupplier',
                className: 'form-control',
            },
            remark: {
                id: 'inputRemark',
                className: 'form-control',
            },
        },
        selects: {
            suppliers: {
                id: 'selSuppliers',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            attachment: {
                id: 'spAttachment',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (purchase)
    const purchaseAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchaseAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let responseLocal = responseGet();
            //#endregion variables

            //#region errors default set
            response = await errorsDefaultSetAsync({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region purchase data set
            response = await purchaseDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion purchase data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region purchase add
            purchase.details = purchaseDetails;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                purchase: purchase,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPurchases}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion purchase add

            //#region initialize
            setPurchase(
                purchaseModelGet({
                    buildingId: id,
                    supplierId: '',
                    userId: auth?.user?.uid
                })
            );
            setPurchaseDetails([]);
            $(`#${dtPurchaseDetailsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            $(`#${controls?.selects?.suppliers?.id}`).val('');

            responseLocal = await dateInControlSetAsync({
                date: new Date(),
                purchaseDate: new Date(),
                processType: 1,
                subMethod: currentMethod,
            });

            if (!responseLocal.isSuccess || responseLocal.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            response.msgText = `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${labels?.purchase?.[languageObj?.id]}: <b>${response?.result?.purchase?.number}</b>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'purchaseDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${purchaseDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            purchase.date = !isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ? dateTimeObj?.date : purchase?.date;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion methods (purchase)

    //#region methods (purchase details)
    const dataTablePurchaseDetailsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchaseDetailsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchaseDetailsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: labels?.concept?.[languageObj?.id], width: '40%', orderable: false, },
                    { title: labels?.quantity?.[languageObj?.id], className: 'text-right', orderable: false, width: '10%', },
                    { title: labels?.price?.[languageObj?.id], className: 'text-right', orderData: false, width: '20%', },
                    { title: `${labels?.taxAbbreviated?.[languageObj?.id]} %`, className: 'text-right', orderData: false, width: '10%', },
                    { title: labels?.subTotal?.[languageObj?.id], className: 'text-right', orderable: false, width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                ordering: true,
                paging: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtPurchaseDetailsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchaseDetailAddGetAsync = async ({ e = {}, rowIndex = 0, processType = 0, subMethod = '' }) => {
        const currentMethod = 'purchaseDetailAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region concepts get
            setConcepts([]);

            response = await purchaseExpenseConceptsGetAsync({
                buildingId: id,
                isConceptsDt: true,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setConcepts(response?.result);
            //#endregion concepts get

            //#region methods
            switch (processType) {
                case 0:
                    break;
                case 1:
                    break;
                default:
                    return;
            }

            setProcessType(processType);
            setDtPurchaseDetailsRowIndex(rowIndex);

            setPurchaseDetailShowModal(true);
            //#endregion methods

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (purchase details)

    //#region concepts (methods)
    const conceptsEditDetailsGetAsync = async ({ id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'conceptsEditDetailsGetAsync';
        let response = responseGet();
        try {
            setPurchaseDetailEditDelete({
                expenseConceptId: id,
                description: description,
                rowIndex: rowIndex,
                processType: processType,
                subMethod: currentMethod,
            });
            setProcessType(processType);
            setDtPurchaseDetailsRowIndex(rowIndex);
            $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsEditDetailsPosAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptsEditDetailsPosAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ building: false, purchase: false, purchaseDetail: true, });

            //#region taxes get
            setTaxes([]);

            response = await purchaseTaxesGetAsync({
                buildingId: id,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setTaxes(response?.result || []);
            //#endregion taxes get

            //#region purchase detail get
            const purchaseDetailLocal = purchaseDetails?.find(({ expenseConceptId }) => expenseConceptId === purchaseDetailEditDelete?.expenseConceptId);;
            if (isUndNullEmp({ data: purchaseDetailLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                response.msgText = `${labels?.expenseConcept?.[languageObj?.id]}: <b>${purchaseDetailEditDelete?.description}</b><br/>`;
                response.msgText += `${messages?.cannotBeLocated?.[languageObj?.id]}<br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            setPurchaseDetail(purchaseDetailLocal);

            //#endregion purchase detail get
            setPurchaseDetailEditShowModal(true);
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptDeleteGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'conceptDeleteGetAsync';
        let response = responseGet();
        try {
            //#region old code
            // //#region show message
            // setConcept({
            //     expenseConceptId: '',
            //     description: '',
            //     rowIndex: 0,
            // });

            // let localMsgText = `${labels?.concept?.[languageObj?.id]}: <b>${description}</b><br/>`;
            // localMsgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

            // const swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: localMsgText,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: labels?.no?.[languageObj?.id],
            //     timerProgressBar: false,
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);

            // //#endregion show message

            // //#region delete data

            // if (isConfirmed) {
            //     setConcept({ expenseConceptId: id, description, rowIndex });
            //     $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.id}`)?.trigger('click');
            // }
            // //#endregion delete data
            //#endregion old code

            //#region data set
            setConcept({
                expenseConceptId: id,
                description: description,
                rowIndex: rowIndex,
            });
            $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.id}`)?.trigger('click');
            //#endregion data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptDeletePostAsync';
        let response = responseGet();
        try {
            //#region old
            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region delete concept from purchase details

            // const localPurchaseDetails = purchaseDetails.filter(({ expenseConceptId }) => expenseConceptId !== concept.expenseConceptId);
            // setPurchaseDetails(localPurchaseDetails);

            // //#endregion delete concept from purchase details

            // //#region set subTotal, tax, taxAmount, total, exemptAmount, taxBase

            // response = purchaseDetailsCalculate(neutralValue, localPurchaseDetails, purchase, setPurchase);
            // if (!response?.isSuccess || response?.isWarning) {
            //     sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //     return;
            // }

            // //#endregion set subTotal, tax, taxAmount, total, exemptAmount, taxBase

            // //#region delete row from data table

            // $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(concept.rowIndex)?.remove()?.draw(true);

            // //#endregion delete row from data table

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old code

            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region show message
            let msgTextObj = {
                one: `${labels?.concept?.[languageObj?.id]}: <b>${concept?.description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region expenseConcept delete
                        const purchaseDetailsBefore = purchaseDetails?.filter(({ expenseConceptId }) => expenseConceptId !== concept.expenseConceptId);

                        response = purchaseDetailsCalculate({
                            neutralValue: neutralValue,
                            purchaseDetails: purchaseDetailsBefore,
                            purchase: purchase,
                            setPurchase: setPurchase,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        setPurchaseDetails(purchaseDetailsBefore);
                        //#endregion expenseConcept delete

                        //#region dtExpenseConcept update
                        $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(concept?.rowIndex)?.remove()?.draw(true);
                        //#endregion dtExpenseConcept update

                        await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                        //#region old code
                        // await sendMessageCloseCurrentWindowAsync({
                        //     msgType: 0,
                        //     msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        //     closeWindow: false,
                        //     urlGoTo: response?.urlGoTo,
                        //     auth: auth,
                        //     isLogout: false,
                        //     languageId: languageObj?.id,
                        //     subMethod: currentMethod,
                        // });
                        //#endregion old code
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion concepts (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let suppliersLocal = [supplierModelGet({})];
            //#endregion variables

            setShowLoading({ building: true, purchase: true, purchaseDetail: true, });

            //#region initialize
            setSuppliers([]);
            //#endregion initialize

            //#region dateTime in control set / datatable set
            response = await dateInControlSetAsync({
                date: new Date(),
                purchaseDate: new Date(),
                type: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                return;
            }

            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                return;
            }
            //#endregion dateTime in control set / datatable set

            //#region building get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlPurchases,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuilding(response?.result?.buildings?.find(({ id: idLocal, }) => idLocal === id) || {});
            } else {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                response.msgType = 1;
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}<br/>`;
                response.msgText += `${messages?.pleaseContactTheSupportDepartment?.[languageObj?.id]}`;
                response.urlGoTo = backend?.urlPurchases;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //showViewLocal = true;
            //#endregion building get

            //#region suppliers get
            //if (showViewLocal) {
            response = await purchaseSuppliersGetAsync({
                buildingId: id,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }

            suppliersLocal = response?.result || [];
            suppliersLocal?.sort((a, b) => a?.[dbProps?.description]?.toLowerCase()?.localeCompare(b?.[dbProps?.description]?.toLowerCase()));
            setSuppliers(suppliersLocal);
            //}
            //setShowView(showViewLocal);
            //#endregion suppliers get

            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        purchaseDate = {},
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: purchaseDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: purchaseDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndefined(date) && !isNull(date)) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (processType === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: globalSettings?.react?.tempusDominus?.icons,
                    buttons: globalSettings?.react?.tempusDominus?.buttons,
                    tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${purchaseDateId}`)?.datetimepicker({
                    date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                    default: false,
                    format: dateTimeObj?.formatTwo,
                });
            } else if (processType === 1) {
                $(`#${purchaseDateId}`)?.datetimepicker('date', moment(dateTimeObj?.date, dateTimeObj?.formatTwo));
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            //#region dataTables set
            response = await dataTablePurchaseDetailsSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion dataTables set

            //#region query set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion query set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorsDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorsDefaultSetAsync';
        let response = responseGet();
        try {
            setDateError('');
            setNumberError('');
            setSupplierError('');
            setPurchaseNumberError('');
            setPurchaseDescriptionError('');
            setPurchaseControlNumberError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region method
            response = await purchaseFormDataValidateAsync({
                purchase: purchase,
                purchaseDetails: purchaseDetails,
                dtPurchaseDetailsId: dtPurchaseDetailsId,
                purchaseDateInputId: controls?.inputs?.date?.id,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess) {
                return response;
            }

            if (response?.isWarning) {
                setNumberError(response?.result?.numberErrorSet);
                setDateError(response?.result?.dateErrorSet);
                setSupplierError(response?.result?.supplierErrorSet);
                setPurchaseNumberError(response?.result?.purchaseNumberErrorSet);
                setPurchaseControlNumberError(response?.result?.purchaseControlNumberErrorSet);
                setPurchaseDescriptionError(response?.result?.purchaseDescriptionErrorSet);
                if (!isUndNullEmp({ data: response?.msgText, subMethod: currentMethod })?.result ||
                    !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod })?.result) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                }
            }
            //#endregion method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region method
            $(`#${dtPurchaseDetailsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            conceptsEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            conceptsEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            conceptDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            response = await errorsDefaultSetAsync({ subMethod: currentMethod });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            window.location.href = backend?.urlPurchases;
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.className);

                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.purchaseNumber?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.date?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.purchaseNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.purchaseControlNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.remark?.id}`).attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.purchaseDetails?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchaseDetails?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='purchases' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.purchases?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={backend?.urlPurchases}>{labels?.purchases?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.create?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {/*buildings*/}
                        <BuildingHeader buildingsId={''}
                            building={building}
                            buildings={[]}
                            btnSyncDisabled={''}
                            methodGetAsync={null}
                            processType={1}
                            showLoading={showLoading?.building}
                            headerSectionValues={{}}
                            languageObj={languageObj} />

                        {/*purchase*/}
                        <div className='row'>
                            <div className='col-12'>
                                <form onSubmit={(e) => purchaseAddPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                                    <div className='card card-outline card-primary shadow' >
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.purchase}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.invoiceLogo} style={styles?.cardHeaderLogo}></img> - {labels?.purchase?.[languageObj?.id]} ({labels?.create?.[languageObj?.id]?.toLowerCase()})
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseNumber?.id}
                                                                className={controls?.inputs?.purchaseNumber?.className}
                                                                //autoFocus
                                                                maxLength={globalSettings?.documentNumberLength?.purchase}
                                                                onChange={(e) => setPurchase({
                                                                    ...purchase,
                                                                    number: numberSet({
                                                                        number: e?.target?.value,
                                                                        type: 'i',
                                                                        languageId: languageObj?.id,
                                                                        subMethod: 'input - purchaseNumberInternal',
                                                                    })?.result
                                                                })}
                                                                onFocus={() => setNumberError('')}
                                                                placeholder={labels?.number?.[languageObj?.id]}
                                                                //disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={labels?.number?.[languageObj?.id]}
                                                                value={purchase?.number || 0} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.sortNumericUpAlt} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(numberError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-center'>
                                                        {
                                                            purchaseStatusGet({
                                                                purchase: purchase || purchaseModelGet({}),
                                                                showStateLabel: true,
                                                                htmlParser: true,
                                                                languageId: languageObj?.id,
                                                                subMethod: 'lbl - purchaseStatus',
                                                            })?.result
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <div id={purchaseDateId} className='input-group date' data-target-input='nearest'>
                                                                <input id={controls?.inputs?.date?.id}
                                                                    className={controls?.inputs?.date?.className}
                                                                    data-target={`#${purchaseDateId}`}
                                                                    data-toggle='datetimepicker'
                                                                    //disabled={!showView}
                                                                    onFocus={() => setDateError('')}
                                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                                    //tabIndex={-1}
                                                                    tooltip='tooltip'
                                                                    title={labels?.date?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append' data-target={`#${purchaseDateId}`} data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <select id={controls?.selects?.suppliers?.id}
                                                                className={controls?.selects?.suppliers?.className}
                                                                onChange={(e) => setPurchase({ ...purchase, supplierId: e?.target?.value })}
                                                                onFocus={() => setSupplierError('')}
                                                                placeholder={labels?.supplier?.[languageObj?.id]}
                                                                //disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={labels?.supplier?.[languageObj?.id]}
                                                                defaultValue={purchase?.supplierId || ''} >
                                                                <option key='nothing' value=''>{labels?.selectSupplier?.[languageObj?.id]}</option>
                                                                {suppliers?.map((supplier = supplierModelGet({})) => <option key={supplier?.id} value={supplier?.id}>{supplier?.description}</option>)}
                                                            </select>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-user-tie' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(supplierError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-muted'>
                                                        <div className='input-group'>
                                                            <div className={controls?.checkBox?.isNational?.className}>
                                                                <input id={controls?.checkBox?.isNational?.id}
                                                                    checked={suppliers?.find(({ id }) => id === purchase?.supplierId)?.national || false}
                                                                    //onChange={(e) => setPurchase({...purchase, national: e.target.checked,})}
                                                                    readOnly
                                                                    tooltip='tooltip'
                                                                    title={labels?.isNational?.[languageObj?.id]}
                                                                    type='checkbox' />
                                                                <label htmlFor={controls?.checkBox?.isNational?.id}
                                                                    tooltip='tooltip'
                                                                    title={labels?.isNational?.[languageObj?.id]}>
                                                                    {labels?.isNational?.[languageObj?.id]}?
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseNumberSupplier?.id}
                                                                className={controls?.inputs?.purchaseNumberSupplier?.className}
                                                                maxLength={globalSettings?.documentNumberLength?.invoice}
                                                                onChange={(e) => setPurchase({ ...purchase, invoiceNumber: e?.target?.value })}
                                                                onFocus={() => setPurchaseNumberError('')}
                                                                placeholder={labels?.invoiceNumber?.[languageObj?.id]}
                                                                //disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={labels?.invoiceNumber?.[languageObj?.id]}
                                                                value={purchase?.invoiceNumber || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-file-invoice-dollar' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseNumberError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>

                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseControlNumberSupplier?.id}
                                                                className={controls?.inputs?.purchaseControlNumberSupplier?.className}
                                                                maxLength={globalSettings?.documentNumberLength?.invoice}
                                                                onChange={(e) => setPurchase({ ...purchase, invoiceControlNumber: e?.target?.value })}
                                                                onFocus={() => setPurchaseControlNumberError('')}
                                                                placeholder={labels?.controlNumber?.[languageObj?.id]}
                                                                //disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={labels?.controlNumber?.[languageObj?.id]}
                                                                value={purchase?.invoiceControlNumber || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-file-signature' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseControlNumberError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <textarea id={controls?.inputs?.remark?.id}
                                                                className={controls?.inputs?.remark?.className}
                                                                onChange={(e) => setPurchase({ ...purchase, description: e?.target?.value, })}
                                                                onFocus={() => setPurchaseDescriptionError('')}
                                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                                //disabled={!showView}
                                                                rows={2}
                                                                tooltip='tooltip'
                                                                title={labels?.remark?.[languageObj?.id]}
                                                                value={purchase?.description || ''}>
                                                            </textarea>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.spellCheck} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseDescriptionError)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-footer'>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.save?.id}
                                                    className={controls?.buttons?.save?.className}
                                                    //disabled={!showView} 
                                                    //hidden={!showView}
                                                    tooltip='tooltip'
                                                    title={labels?.save?.[languageObj?.id]}
                                                    type='submit'>
                                                    <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.attachment?.id}
                                                    className={controls?.buttons?.attachment?.className}
                                                    disabled
                                                    tooltip='tooltip'
                                                    title={labels?.toAttach?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.back?.id}
                                                    className={controls?.buttons?.back?.className}
                                                    onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - back', })}
                                                    tooltip='tooltip'
                                                    title={labels?.back?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/*purchase (details)*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow' >
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.purchaseDetail}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.shoppingCart} style={styles?.cardHeaderLogo}></img> - {labels?.purchase?.[languageObj?.id]} ({labels?.detail?.[languageObj?.id]?.toLowerCase()})
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12 text-muted'>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.className}
                                                    //disabled={!showView}
                                                    tooltip='tooltip'
                                                    title={labels?.addDetail}
                                                    type='button'
                                                    onClick={(e) => purchaseDetailAddGetAsync({ e: e, rowIndex: 0, processType: 0, subMethod: 'btn - purcaseDetailAdd', })}>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.className}
                                                    hidden={true}
                                                    onClick={(e) => conceptsEditDetailsPosAsync({ e: e, subMethod: 'btn - purchaseDetailConceptEditDetail', })}
                                                    tooltip='tooltip'
                                                    title={labels?.edit?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailEdit?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailEdit?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailEdit?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.className}
                                                    //disabled={!showView}
                                                    hidden={true}
                                                    onClick={(e) => conceptDeletePostAsync({ e: e, subMethod: 'btn - expenseConceptDelete', })}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailDelete?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailDelete?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailDelete?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPurchaseDetailsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>

                                        {/*resumen*/}
                                        <div className='row'>
                                            <div className='col-md-6'>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='table-responsive'>
                                                    <table className='table table-sm'>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ width: '50%' }}>{labels?.subTotal?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.subTotal || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseSubTotal',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{labels?.taxBase?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxBase || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxBase',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{labels?.exemptAmount?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase?.exemptAmount) ? purchase?.exemptAmount : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.exemptAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseExemptAmount',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{labels?.tax?.[languageObj?.id]} ({
                                                                    //separatorsNumbersSet(!isUndefined(purchase?.taxPercentage) ? purchase?.taxPercentage : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxPercentage || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxPercentage',
                                                                    })?.result
                                                                } %):</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase?.taxAmount) ? purchase?.taxAmount : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxAmount',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{labels?.total?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase?.total) ? purchase?.total : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.total || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTotal',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{labels?.balance?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase?.balance) ? purchase?.balance : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.balance || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseBalance',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

            {purchaseDetailShowModal ?
                <PurchaseConceptAdd $={$}
                    auth={auth}
                    purchase={purchase}
                    purchaseDetails={purchaseDetails}
                    setPurchaseDetails={setPurchaseDetails}
                    concepts={concepts}
                    dtId={dtPurchaseDetailsId}
                    showModal={purchaseDetailShowModal}
                    setShowModal={setPurchaseDetailShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }

            {purchaseDetailEditShowModal ?
                <PurchaseConceptEdit $={$}
                    auth={auth}
                    neutralValue={neutralValue}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    purchaseDetail={purchaseDetail}
                    setPurchaseDetail={setPurchaseDetail}
                    purchaseDetails={purchaseDetails}
                    setPurchaseDetails={setPurchaseDetails}
                    dtId={dtPurchaseDetailsId}
                    rowIndex={dtPurchaseDetailsRowIndex}
                    taxes={taxes}
                    showModal={purchaseDetailEditShowModal}
                    setShowModal={setPurchaseDetailEditShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }

        </div>
    )
}